import {
    CHILE,
    COUNTRY_SECTION_NAME,
    HEAR_ABOUT_US_SECTION_NAME,
    SHOP_FORM_SECTION_NAME,
    VENDOR_FORM_SECTION_NAME
} from "../../constants";

const getSectionsErrorMessages = (countryCode) => {
  const documentNumberAlias = countryCode === CHILE.value ? 'RUT' : 'DNI';
  const exampleDocNumberFormat =
    countryCode === CHILE.value ? '99999999-k' : '999999999';
  const documentNumberMinLength = countryCode === CHILE.value ? '8' : '10';
  const documentNumberMaxLength = countryCode === CHILE.value ? '9' : '10';
  const idSocialReasonAlias =
    countryCode === CHILE.value ? 'RUT de la razón social' : 'RUC';
  const idSocialReasonMinLength = countryCode === CHILE.value ? '9' : '10';
  const idSocialReasonMaxLength = '10';
  const examplePhoneFormat =
    countryCode === CHILE.value ? '+56999999999' : '999999999';
  const phoneErrorMsg = `El teléfono ingresado no es válido. Escríbelo siguiendo este formato: ${examplePhoneFormat}`;
  const exampleEmailFormat =
    countryCode === CHILE.value ? 'contacto@email.cl' : 'contacto@email.com.pe';
  const emailErrorMsg = `El correo ingresado no es válido. Escríbelo siguiendo este formato: ${exampleEmailFormat}`;
  return {
    [VENDOR_FORM_SECTION_NAME]: {
      'required.name': 'Ingresa tu nombre',
      'required.lastname': 'Ingresa tu apellido',
      'required.phone': 'Ingresa el teléfono de contacto de tu tienda',
      'regex.phone': phoneErrorMsg,
      'max.phone': phoneErrorMsg,
      'required.email': 'Ingresa el correo electrónico de tu tienda',
      'email.email': emailErrorMsg,
      'required.repeat_email': 'Es necesario validar su correo',
      'email.repeat_email': emailErrorMsg,
      'required.document_number': `Ingresa tu ${documentNumberAlias}`,
      'numeric.document_number': `El ${documentNumberAlias} solo debe contener números`,
      'min.document_number': `El ${documentNumberAlias} debe tener un largo mínimo de ${documentNumberMinLength}`,
      'max.document_number': `El ${documentNumberAlias} debe tener un largo máximo de ${documentNumberMaxLength}`,
      'regex.document_number': `El ${documentNumberAlias} ingresado no es válido. Escríbelo siguiendo este formato: ${exampleDocNumberFormat}`,
    },
    [SHOP_FORM_SECTION_NAME]: {
      'required.commercial_name': 'Ingresa el nombre comercial de tu tienda',
      'required.business_name': 'Ingresa la razón social de tu tienda',
      'required.main_category':
        'Selecciona la categoría principal de tu tienda',
      'required.economic_activity': 'Selecciona el giro de la empresa',
      'array.economic_activity': 'Selecciona el giro de la empresa',
      'required.id_social_reason': `Ingresa el ${idSocialReasonAlias}`,
      'min.id_social_reason': `El ${documentNumberAlias} debe tener un largo mínimo de ${idSocialReasonMinLength}`,
      'max.id_social_reason': `El ${documentNumberAlias} debe tener un largo máximo de ${idSocialReasonMaxLength}`,
      'regex.id_social_reason': `El ${idSocialReasonAlias} ingresado no es válido. Escríbelo siguiendo este formato: ${exampleDocNumberFormat}`,
    },
    [HEAR_ABOUT_US_SECTION_NAME]: {
      'required.hear_about_us': 'Indica cómo te enteraste de esta inscripción',
    },
    [COUNTRY_SECTION_NAME]: {
      'required.country': 'Selecciona el país',
    },
  };
};

const errorMessages = {
    getBySectionName: (countryCode, sectionName) => {
        const sectionsErrorMsgs = getSectionsErrorMessages(countryCode);
        return sectionsErrorMsgs[sectionName];
    },
    getAll: (countryCode) => {
      return getSectionsErrorMessages(countryCode);
    },
}

export default errorMessages